import React, { useContext, useState } from "react";
import Box from "@mui/material/Box";
import { Modal, Button } from "@mui/material";
import ModalFooter from "./ModalFooter";
import VendorPayments from "../View/VendorPayments";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { IconButton } from "rsuite";
import CustomTabs from "../component/CustomTabs";
import AuthContext from "../store/AuthContext";
import { vendor_tab_value } from "../utils/constants";

const modalStyle = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  fontFamily: "Poppins",
  p: 2,
  overflowY: "auto",
};

const SuperTransferModel = ({ resetView }) => {
  const [open, setOpen] = useState(true); 
  const [request, setRequest] = useState(false);
  const [value, setValue] = useState(0);
  const [currentType, setCurrentType] = useState(0);
  const [type, settype] = useState("express");

  const authCtx = useContext(AuthContext);
  const user = authCtx.user;

  const tabs = [
    { label: "Wallet", component: VendorPayments, type: "express" },
    user?.st === 1 && { label: "Vendor Payment", component: VendorPayments, type: "super" },
    user?.st2=== 1 && { label: "Vendor Payment2", component: VendorPayments, type: "super2" },
    user?.wp === 1 && { label: "Wallet Pay", component: VendorPayments, type: "walletPay" },
  ].filter(Boolean); 

  const handleChange = (event, newValue) => {
    setValue(newValue);
    const selectedTab = tabs[newValue];
    settype(selectedTab.type);
    setCurrentType(newValue);
  };

  const handleClose = () => {
    resetView(null);
  };

  const ActiveComponent = tabs[value]?.component || null;

  return (
    <Box>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="send-notification-title"
        aria-describedby="send-notification-description"
      >
        <Box sx={modalStyle}>
          {/* Header */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Button
              variant="contained"
              color="primary"
              startIcon={<ArrowBackIcon />}
              onClick={handleClose}
              sx={{
                backgroundColor: "#1976d2",
                color: "#fff",
                "&:hover": {
                  backgroundColor: "#115293",
                },
                textTransform: "none",
                borderRadius: "8px",
                fontFamily: "Poppins",
                fontWeight: 500,
                fontSize: "19px",
              }}
            >
              Back
            </Button>

            <IconButton
              onClick={handleClose}
              sx={{
                fontSize: "29px",
                color: "#000",
              }}
            >
              <CloseRoundedIcon />
            </IconButton>
          </Box>

          {/* Tabs */}
          <CustomTabs tabs={tabs} value={value} onChange={handleChange} />

          {/* Render current tab's component and pass type */}
          <Box sx={{ "& .MuiTextField-root": { m: 2 } }}>
            {ActiveComponent && <ActiveComponent key={type} type={type} />}
          </Box>

          {/* Footer */}
          <Box sx={{ textAlign: "right", mr: 2 }}>
            {/* <ModalFooter form="send_notification" request={request} btn="Send" /> */}
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default SuperTransferModel;
